var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",staticClass:"card",class:{
		'card--selected': _vm.isSelected,
		'card--hoverable': _vm.isHoverable,
		'card--clickable': _vm.isClickable,
		'card--clickable--active': _vm.hasA11yFocus,
		'no-outline': _vm.isHoverable,
		'no-shadow': _vm.disableShadow,
		'card--unread': _vm.isUnread,
		'card--merged': _vm.isMergedList,
		'card--tight': _vm.spacing === _vm.Spacing.TIGHT,
		'card--regular': _vm.spacing === _vm.Spacing.REGULAR,
		'card--wide': _vm.spacing === _vm.Spacing.WIDE,
		'card--loose': _vm.spacing === _vm.Spacing.LOOSE,
		'card--extra-loose': _vm.spacing === _vm.Spacing.EXTRA_LOOSE,
		'card--has-error': _vm.hasError,
		'card--has-warning': _vm.hasWarning,
		'card--has-success': _vm.hasSuccess,
		'card--has-slot-children': _vm.hasSlotChildren,
	}},_vm.$listeners),[_vm._t("a11yClickHandler",[(_vm.isClickable)?_c('button',{staticClass:"click-activator offscreen-text",on:{"focus":function($event){_vm.hasA11yFocus = true},"blur":function($event){_vm.hasA11yFocus = false},"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.a11yClickCardText)+" ")]):_vm._e()],{"bind":{
			class: 'click-activator offscreen-text',
		},"listeners":{
			focus: _vm.onA11yFocus,
			blur: _vm.onA11yBlur,
		},"text":_vm.a11yClickCardText}),_vm._t("default"),(_vm.hasError || _vm.hasWarning || _vm.hasSuccess)?_c('div',{staticClass:"card__notice",class:{
			'card__error': _vm.hasError,
			'card__warning': _vm.hasWarning,
			'card__success': _vm.hasSuccess,
		}},[_c('div',{staticClass:"card__notice--left"},[_c('font-awesome-icon',{attrs:{"icon":_vm.noticeIcon,"fixed-width":""}})],1),_c('div',{staticClass:"card__notice--right",attrs:{"testid":"card__notice__right"}},[(_vm.hasError)?_vm._t("error"):_vm._e(),(_vm.hasWarning)?_vm._t("warning"):_vm._e(),(_vm.hasSuccess)?_vm._t("success"):_vm._e()],2)]):_vm._e(),(_vm.isUnread && _vm.useUnreadDot && _vm.unreadDotAria)?_c('div',{staticClass:"unread-dot",attrs:{"aria-label":_vm.unreadDotAria}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }